import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import { t } from 'i18next';
import { startCase } from 'lodash-es';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Invoice } from '~hooks/useInvoices/models';
import { getLargestDeliveredQuantitySum } from '~utils/jobs/job-utils';

import { FlexColumn } from '../../styled';

interface TicketQuantityColumnProps {
  invoice: Invoice;
  sx?: SxProps<Theme>;
}

const TicketQuantityColumn = ({ invoice, sx }: TicketQuantityColumnProps) => {
  const deliveredQuantities = invoice.jobSummary?.deliveredQuantities ?? [];
  const { total, unitOfMeasure } = getLargestDeliveredQuantitySum(deliveredQuantities);

  const formattedTotal = total.toFixed(2);
  const unitLabel = unitOfMeasure ? startCase(unitOfMeasure) : '';

  return (
    <Box sx={sx}>
      <FlexColumn>
        <OverflowAwareText fontWeight={700}>
          {`${formattedTotal} ${unitLabel}`}
        </OverflowAwareText>

        <OverflowAwareText>
          {invoice.ticketsCount} {t('approvals.driver_day.tickets')}
        </OverflowAwareText>
      </FlexColumn>
    </Box>
  );
};

export default TicketQuantityColumn;
